module.exports = __webpack_public_path__ + "static/media/sf_1000.a96978289e7d479615c358a7271fd34d.png";